<template>
  <v-app-bar app class="nonvisible"   color="#FBDE3C">
    <v-layout align-center>
      <v-col cols="3">
        <v-img style="cursor: pointer" @click="returnToHome()" src="@/assets/logo.svg" height="50px" contain></v-img>
      </v-col>

      <v-col cols="6">
        <v-layout row>
          <span class="font-weight-bold mt-1">{{usertest.username}}</span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
              <v-btn small dark primary class="ml-3"   v-bind="attrs"
          v-on="on" @click="reloadFunction">odśwież sesję</v-btn>
          </template>
          <span>Odśwież sesję w przypadku problemu z dodaniem zamówienia lub komentarza.</span>
        </v-tooltip>
        </v-layout>
      </v-col>
      <v-col cols="3">
        <v-btn
          color="primary"
          v-if="usertest && usertest.roleId === 3"
          depressed
          @click="goToAdmin"
          class="mr-2"
        >Panel administratora</v-btn>
        <v-btn color="transparent" v-if="this.$store.state.auth.status.loggedIn" depressed @click="logOut" class="black--text" >WYLOGUJ<v-icon class="ml-1" color="black">mdi-logout-variant</v-icon></v-btn>
      </v-col>
    </v-layout>
  </v-app-bar>
</template>

<script>
export default {
  computed: {
    usertest() {
      // Pobierz użytkownika ze store lub z localStorage jako fallback
      return this.$store.state.auth.user || JSON.parse(window.localStorage.getItem('user')) || {};
    }
  },
  methods: {
    reloadFunction() {
      location.reload(true);
    },
    returnToHome() {
      this.$router.push("/zamowienia");
    },
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    goToAdmin() {
      this.$router.push('/admin');
    }
  }
};


</script>

<style>
</style>